/*
 * Copyright (c) 2020.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {HttpParams} from '@angular/common/http';
import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {NbWindowService} from '@nebular/theme';
import {FormlyFieldConfig, FormlyFormOptions} from '@ngx-formly/core';
import {BreadcrumbDto, DamElasticDTO, DamEventService, FileService, PageApiResponse, StoreService} from 'compob2b-libs';
import {FileUploader} from 'ng2-file-upload';
import {EMPTY, from, Observable, Subscription} from 'rxjs';
import {catchError, concatMap, debounceTime, finalize, map, takeUntil, tap} from 'rxjs/operators';
import {translations} from '../../../../../environments/translations.ru';
import {ListComponent} from '../../../../admin-shared/crud-components/list/list.component';
import {CrudConfig} from '../../../../admin-shared/interfaces/crud.config';
import {FormConfigService} from '../../../../admin-shared/services/form-config.service';
import {CatalogService} from '../../../pim/catalog/catalog.service';
import {DamService} from '../../dam.service';
import {FILES_FORM} from '../files-forms.config';

interface DocumentFile {
  enabled: boolean;
  header: string;
  fileInput: File;
}

@Component({
  selector: 'app-basket-list',
  templateUrl: './basket-list.component.html',
  styleUrl: './basket-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasketListComponent extends ListComponent<DamElasticDTO> implements OnInit {

  menuId: number;
  uploader: FileUploader;
  uploadURI: string;
  hasDropZoneOver: boolean;
  isUploading = false;
  private subscription: Subscription;

  keyword = '';

  catalogBreadCrumbs: Observable<BreadcrumbDto[]>;
  productShow = false;
  fieldsFeatures: FormlyFieldConfig[];
  options: FormlyFormOptions = {};
  modelFeatures: any = {};
  getFeatures = false;
  readonly showDamFilter$: Observable<boolean> = this.storeService.getShowDamFilter();
  readonly damUploadFinish$: Observable<boolean> = this.damEventService.getDamUploadFinish();
  showDamFilter: boolean;
  config: CrudConfig = {
    uri: '/dam/basket/files',
    columns: FILES_FORM,
    defaultSortColumn: 'header',
    defaultSortDirection: 'asc',
    title: translations.files,
  };

  constructor(protected readonly formsConfig: FormConfigService,
              protected readonly windowService: NbWindowService,
              protected readonly fileService: FileService,
              protected readonly catalogService: CatalogService,
              protected readonly storeService: StoreService,
              protected readonly damService: DamService,
              protected readonly damEventService: DamEventService
  ) {
    super(formsConfig, windowService, fileService);
  }

  ngOnInit(): void {

    this.showDamFilter$.pipe(tap((value) => {
      this.showDamFilter = value;
      this.cdr.detectChanges();
    }), takeUntil(this.unsubscribe)).subscribe();

    this.damUploadFinish$.pipe(tap(value => {
      if (value === true) {
        this.data = this.filterProducts().pipe(catchError(err => {
          this.handleError(err);
          return EMPTY;
        }));
      }
      this.cdr.detectChanges();
    }), takeUntil(this.unsubscribe)).subscribe();

    this.uploader = new FileUploader({
      url: null,
      disableMultipart: false,
      formatDataFunctionIsAsync: false,
      isHTML5: true,
      removeAfterUpload: false,
      autoUpload: false,
      maxFileSize: 25 * 1024 * 1024,
    });

    super.setConfig(this.config);
    this.configure();
    this.route.queryParamMap.pipe(
      debounceTime(500),
      tap(_ => this.data = this.filterProducts().pipe(catchError(err => {
        this.handleError(err);
        return EMPTY;
      }))),
      tap(params => {
        let catalogId = 1;
        if (Number(params.get('catalog_id')) > 1) {
          catalogId = Number(params.get('catalog_id'));
        }
        this.catalogBreadCrumbs = this.damService.getCatalogBreadCrumbs(catalogId);
      }),
      tap(params => this.keyword = params.get('keyword')),
      tap(params => this.menuId = Number(params.get('catalog_id'))),
      // switchMap(params1 => {
      //
      //   let catalogId = 1;
      //   if (Number(params1.get('catalog_id')) > 1) {
      //     catalogId = Number(params1.get('catalog_id'));
      //   }
      //   return this.damFilter.getProductFilter(this.config.uri, catalogId, params1);
      // }),
      tap(_ => this.cdr.detectChanges()),
      takeUntil(this.unsubscribe)
    ).subscribe(response => {
      // this.fieldsFeatures = response.fieldsFeatures;
      // this.fieldsFeatures.forEach(feature => {
      //   if (Array.isArray(feature.defaultValue)) {
      //     const defaultValue = [];
      //     feature.defaultValue.forEach(featureDefaultValue => {
      //       defaultValue.push(isNaN(featureDefaultValue)
      //         ? 'null'
      //         : featureDefaultValue);
      //     });
      //     feature.defaultValue = defaultValue;
      //   }
      // });
      // this.modelFeatures = {};
      // this.getFeatures = true;
      this.cdr.detectChanges();
    });

    this.route.queryParamMap.pipe(
      debounceTime(500),
      // switchMap(params1 => {
      //
      //   let catalogId = 1;
      //   if (Number(params1.get('catalog_id')) > 1) {
      //     catalogId = Number(params1.get('catalog_id'));
      //   }
      //   // return this.damFilter.getProductFilterFast(this.config.uri, catalogId, params1);
      // }),
      tap(_ => this.cdr.detectChanges()),
      takeUntil(this.unsubscribe)
    ).subscribe(response => {
      // this.fieldsFeaturesFast = response.fieldsFeatures;
      // this.fieldsFeaturesFast.forEach(feature => {
      //   if (Array.isArray(feature.defaultValue)) {
      //     const defaultValue = [];
      //     feature.defaultValue.forEach(featureDefaultValue => {
      //       defaultValue.push(isNaN(featureDefaultValue)
      //         ? 'null'
      //         : featureDefaultValue);
      //     });
      //     feature.defaultValue = defaultValue;
      //   }
      // });
      // this.modelFeaturesFast = {};
      this.cdr.detectChanges();
    });

  }

  private filterProducts(): Observable<DamElasticDTO[]> {
    return this.filterDataDam();
  }

  filterFinish(id: number): void {
    window.location.reload();
  }

  public filterDataDam(): Observable<DamElasticDTO[]> {

    if (!this.loading) {
      this.loading = true;
      const params = this.route.snapshot.queryParams;

      this.updatePagerFromUri();
      const uri = this.getListURI(this.config.uri + '/' + (params.catalog_id || 0));

      return this.compoApiService.getWithParams<PageApiResponse<DamElasticDTO[]>>(uri, new HttpParams({fromObject: params}))
        .pipe(
          catchError(err => this.handleError(err)),
          tap(response => this.handleResponse(response.data)),
          map(response => response.data?.content)
        );
    }
  }

  public documentUri(fileName: string): string {
    return this.fileService.getPublicDocumentUri(fileName);
  }

  private uploadFile(uploadingFile: File): Observable<any> {
    this.uploadURI = '/dam/upload/' + this.menuId;
    return this.compoApiService.postForm<DocumentFile, string>(
      this.uploadURI, {enabled: true, header: uploadingFile.name, fileInput: uploadingFile}
    );
  }

  public download(fileName: string): void {
    this.fileService.downloadUrl('/documents/files/download/' + fileName)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(response => {
        FileService.saveAs(response, fileName);
      });
  }

  public fileOver(e: any): void {
    this.hasDropZoneOver = e;
  }

  public upload(): void {
    this.isUploading = true;
    if (this.uploader.queue.length) {
      this.subscription = from(this.uploader.queue)
        .pipe(
          map(uploadingFile => uploadingFile._file),
          concatMap(uploadingFile => this.uploadFile(uploadingFile)),
          finalize(() => this.finishUpload()),
          takeUntil(this.unsubscribe)
        ).subscribe();
      this.hasDropZoneOver = false;
    }
  }

  private finishUpload(): void {
    this.uploader.clearQueue();
    this.subscription.unsubscribe();
    this.filterFinish(this.route.snapshot.params.catalog_id);
    this.isUploading = false;

  }

  searchByKeyword() {
    if (this.keyword === '') {
      this.keyword = null;
    }

    this.onNavigate({keyword: this.keyword, page: null});
  }

  showProductInfo() {
    this.productShow = true;
  }

  isImage(type: string): boolean {
    return type.startsWith('image');
  }

}
